import {api} from "../../services";
import Swal from "sweetalert2";

const templates = {
    state: {
        data: {},
        pagination: {},
        template: {},
        templates_searched_channel_id: null,
        step: 1,
        new: {
          header: {
            format: "TEXT",
            content: "",
            examples: []
          },
          body: {
            text: "",
            examples: []
          },
          footer: {
            text: ""
          },
          buttons: [],
          category: null,
          name: null,
          language: null,
          options: {
            header: false,
            body: true,
            footer: false,
            buttons: false,
          },
          header_file: {
            text: '',
            file: null,
            mimetype: null,
            filename: null
          }
        },
        buttons_default: [
          {
            type: "QUICK_REPLY",
            text: ""
          },
          {
            type: "PHONE_NUMBER",
            text: "",
            phone_number: ""
          },
          {
            type: "URL",
            text: "",
            url: ""
          },
        ],
        show_template_by_language: false
    },
    getters: {
      getTemplatesOfChannelFilter: (state, context, rootState) => () => {
        if (state.data !== undefined) {
          let templates;

          if (state.show_template_by_language === false) {
            templates = state.data
          } else {
            let language = rootState.me.data.language_key === 0 ?
              ['pt_BR'] : rootState.me.data.language_key === 1 ? ['en_US', 'en'] : ['es'];

            templates = state.data.filter(template => {
              if(language.length === 1) {
                return template.language === language[0];
              }
              else {
                return template.language === language[0] || template.language === language[1];
              }
            })
          }
          return templates;
        }
      },
    },
    mutations: {
        SET_TEMPLATES(state, payload) {
            state.data = payload
        },
        SET_TEMPLATES_PAGINATION_CLOUD_API(state, payload) {
            state.pagination = payload
        },
        SET_TEMPLATE(state, payload) {
            state.template = payload
        },
        SET_STEP(state, payload) {
            state.step = payload
        },
    },
    actions: {
        getTemplates(context, payload) {
          let endpoint = null;
          const channel = context.rootGetters.getChannelObject('id', payload.id)
          const is_dialog_active = channel.integrations[9].status_key;
          const is_cloudapi_active = channel.integrations[12] && channel.integrations[12].status_key;

          if (is_dialog_active) {
            endpoint = `/channels/hsm/${payload.id}`;
          } else if (is_cloudapi_active) {
            endpoint = `/channels/hsm/list/${payload.id}`;
          }
       const params = {
            page: payload.page || 1,
            limit: payload.limit || 5
        };
        
        if (payload.search) {
            params.search = payload.search;
        }
        // console.log('API CALL →', endpoint, params);
            api.get(endpoint, { params }).then(response => {
              if (is_dialog_active) {
                context.commit("SET_TEMPLATES", response.data.waba_templates);
              } else if (is_cloudapi_active) {
                context.commit("SET_TEMPLATES_PAGINATION_CLOUD_API", response.data.data);
                context.commit("SET_TEMPLATES", response.data.data.data);
              }
              context.state.templates_searched_channel_id = payload.id;
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
        addTemplate(context, payload) {
            api.post(`/channels/hsm/${payload.channel_id}`, payload).then(() => {
                this.dispatch('getTemplates', {id: payload.channel_id})
                context.commit("SET_STEP", 3);
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    context.commit("SET_STEP", 1);
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
        updateTemplate(context, payload) {
            api.put(`/templates/${payload.id}`, payload).then(response => {
                this.dispatch('getTemplates', {channel_id: payload.channel_id})
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: context.rootGetters.getTranslations('expression_965'),
                    showConfirmButton: false,
                    timer: 1500
                })
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
        deleteTemplate(context, payload) {
            api.delete(`/channels/hsm/${payload.id}`, {
              params: {
                template_name: payload.template_name
              }
            }).then(() => {
              this.dispatch('getTemplates', {id: payload.id})
                Swal.fire(
                  `${ context.rootGetters.getTranslations('expression_1244') }`,
                  `${ context.rootGetters.getTranslations('expression_1245') }`,
                  'success'
                )
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_683') }`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
    },
}
export default templates;
